<template>
  <div v-if="data" class="dialog-wrap">
    <b-dialog
      :mask="dialogData.mask"
      :mshow="dialogData.show"
      :maskOpacity="dialogData.maskOpacity"
      :maskBackground="dialogData.maskBackground"
      :maskClass="maskClass"
    >
      <div class="upgrade-pop-box" :class="renderCls">
        <div class="block"></div>
        <div class="level-icon">
          <beast-image :src="data.levelIcon" />
        </div>
        <div class="pop-title">{{ data.title }}</div>
        <div class="pop-desc">{{ data.desc }}</div>
        <div class="pop-items">
          <div class="pop-item" v-for="(item, index) in data.vipBenefits" :key="index">
            <div class="pop-icon">
              <beast-image :src="item.icon" />
            </div>
            <div class="pop-name">{{ item.name }}</div>
          </div>
        </div>
        <div class="pop-btn" :class="renderCls" @click="benefitAction">查看更多专属特权</div>
        <div class="upgrade-close-box" @click="upgradePopClose">
          <div class="upgrade-close"></div>
        </div>
      </div>
    </b-dialog>
  </div>
</template>

<script>
import BDialog from '@/components/dialog'
import beastImage from '@/components/image'

import { ensure_protocol } from '@beastshop/url-util'
import { transformLink, trackSkip } from '@/link'
import { lazyload } from '@/lazyload'
import track from '@/track'
import browser from '@beastshop/browser'
import bridge from '@beastshop/bridge'

export default {
  name: 'upgrade-pop',
  props: {
    id: Number,
    data: {
      type: Object,
      default: {}
    },
    dialog: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      maskClass: {
        'pop-anima': true
      },
      dialogData: {
        mask: (this.dialog.mask === undefined)?true:this.dialog.mask,
        show: (this.dialog.show === undefined)?true:this.dialog.show,
        maskOpacity: (this.dialog.maskOpacity === undefined)?'0.4':this.dialog.maskOpacity,
        maskBackground: (this.dialog.maskBackground === undefined)?'#000000':this.dialog.maskBackground
      },
    }
  },
  components: {
    BDialog,
    beastImage
  },
  computed: {
    renderCls () {
      const level = this.data.level
      const cls = {}
      if(level === 1) {
        cls.one = true
      }
      if(level === 2) {
        cls.two = true
      }
      if(level === 3) {
        cls.three = true
      }
      if(level === 4) {
        cls.four = true
      }
      return cls
    }
  },
  created () {
  },
  methods: {
    benefitAction () {
      track({
        name: 'upgrade-pop-click',
        attrs: {},
        wait: false
      })

      this.$emit('upgrade-close')

      if(browser.app()) {
        bridge.open({
          url: 'beastapp://entry?name=benefit'
        })
      } else {
        window.location.href = '/my/benefit'
      }
    },

    upgradePopClose () {
      this.$emit('upgrade-close')
    }
  },
}
</script>

<style lang="stylus">
@import '../../common/styl/global.styl'
.pop-anima
  animation pop 400ms
.upgrade-pop-box
  width rem(280)
  padding rem(34) rem(28) rem(28)
  border-radius rem(8)
  background #FBC978
  color #000000
  font-weight bold
  box-sizing border-box
  &.one
    background #96AE79
  &.two
    background #FF6152
  &.three
    background #A5C8D2
  &.four
    background #FFD2BF
  .block
    width 100%
    height 1px
  .level-icon
    width rem(130)
    height rem(130)
    border-radius 50%
    margin 0 auto rem(20)
    img
      width 100%
  .pop-title
    width 100%
    text-align center
    font-size rem(20)
    margin-bottom rem(3)
  .pop-desc
    width 100%
    text-align center
    font-size rem(14)
    margin-bottom rem(35)
  .pop-items
    width 100%
    margin-bottom rem(24)
    .pop-item
      width 33.33%
      text-align center
      display inline-block
      .pop-icon
        display inline-block
        width rem(34)
        height rem(34)
        margin-bottom rem(8)
      .pop-name
        width 100%
        font-size rem(12)
  .pop-btn
    width 100%
    height rem(40)
    line-height rem(40)
    border-radius rem(4)
    font-size rem(14)
    font-weight bold
    color #ffffff
    text-align center
    background #984C46
    &.one
      background #ffffff
      color #000000
    &.two
      background #13354E
    &.three
      background #305C6B
    &.four
      background #141414
      color #fff


  .close-box
    width rem(32)
    height rem(32)
    border rem(1.5) solid #ffffff
    border-radius 50%
    background transparent
    margin rem(50) auto 0
    position relative
    .close
      position absolute
      width rem(18)
      height rem(1.5)
      background #ffffff
      left 50%
      top 50%
      transform translate(-50%, -50%) rotateZ(45deg)
      &:after
        content ""
        background #ffffff
        display block
        width rem(18)
        height rem(1.5)
        position absolute
        top 0
        left 0
        transform rotateZ(90deg)
  
  .upgrade-close-box
    position absolute
    width rem(22)
    height rem(22)
    top rem(14)
    right rem(14)
    .upgrade-close
      position absolute
      width rem(18)
      height rem(1.5)
      background #000000
      left 50%
      top 50%
      transform translate(-50%, -50%) rotateZ(45deg)
      &:after
        content ""
        background #000000
        display block
        width rem(18)
        height rem(1.5)
        position absolute
        top 0
        left 0
        transform rotateZ(90deg)


@keyframes pop {
  from {
    opacity 0
  }
  to {
    opacity .7 
  }
}
</style>


// WEBPACK FOOTER //
// upgrade-pop.vue?89ddba10